import MainProduct from "$store/components/product/content/BuyTogether/MainProduct.tsx";
import ProductCard from "$store/components/product/content/BuyTogether/ProductCard.tsx";
import Products from "$store/components/product/content/BuyTogether/Products.tsx";
import Total from "$store/components/product/content/BuyTogether/Total.tsx";
import { selectedProducts } from "$store/components/product/content/BuyTogether/selectedProducts.ts";
import type { Product, ProductDetailsPage } from "apps/commerce/types.ts";

export interface Props {
  /**
   * @title Título
   */
  title?: string;

  /**
   * @title Produto principal
   */
  page: ProductDetailsPage | null;

  /**
   * @title Produtos para comprar junto
   */
  products: Product[] | null;
}

export default function BuyTogether({ title, page, products }: Props) {
  if (!page || !products?.length) return null;

  selectedProducts.value = [page.product];

  const { isVariantOf, name, image } = page.product;

  const [highlighted, ...other] = products.filter(({ offers }) =>
    offers?.offers[0].availability === "https://schema.org/InStock"
  );

  return (
    <div class="container px-2 my-20">
      {title && (
        <h2 class="text-tw-neutral-500 text-3xl text-center font-maven font-extrabold">
          {title}
        </h2>
      )}

      <div class="mt-8 grid max-lg:max-w-80 max-lg:mx-auto max-lg:justify-items-center max-lg:gap-10 lg:grid-cols-[1fr_2rem_0.75fr_2rem_0.75fr_2rem_1fr] lg:items-center lg:gap-5">
        <MainProduct
          image={image?.[0].url ?? ""}
          name={name ?? ""}
          groupName={isVariantOf?.name ?? ""}
        />

        <div class="w-8 h-8 rounded bg-tw-base-100 text-tw-primary-200 text-3xl font-bold flex justify-center items-center">
          +
        </div>

        <ProductCard product={highlighted} />

        {!!other.length && (
          <>
            <div class="w-8 h-8 rounded bg-tw-base-100 text-tw-primary-200 text-3xl font-bold flex justify-center items-center">
              +
            </div>

            <Products products={other} />
          </>
        )}

        <div class="w-8 h-8 rounded bg-tw-primary-200 text-white text-3xl font-bold flex justify-center items-center">
          =
        </div>

        <Total />
      </div>
    </div>
  );
}
